<template>
  <div>
    <nav aria-label="breadcrumb" class="content-block">
      <ol class="breadcrumb">
        <li class="breadcrumb-item">
          <a href="#/simpeg-dashboard">Dashboard</a>
        </li>
        <li class="breadcrumb-item">
          <a href="#/final-gaji-list-draft">Daftar Gaji</a>
        </li>
        <li class="breadcrumb-item active" aria-current="page">Print Gaji</li>
      </ol>
    </nav>
    <h5 class="content-block">Print Gaji</h5>
    <div class="content-block">
      <div class="dx-card responsive-paddings">
        <p class="text-muted font-weight-light">Peraturan Penggajian</p>
        <div class="row">
          <!-- <div class="editors"> -->
          <div class="editors-container">
            <div class="col">
              <DxSelectBox
                :dataSource="bulanSource"
                valueExpr="id"
                displayExpr="name"
                width="100%"
                label="Periode Bulan"
                placeholder="Periode Bulan"
                :styling-mode="stylingMode"
                :label-mode="labelMode"
                v-model="filters.bulan"
              >
                <DxValidator>
                  <DxRequiredRule />
                </DxValidator>
              </DxSelectBox>
            </div>
            <div class="col" style="padding-left: 10px">
              <DxSelectBox
                :dataSource="tahunSource"
                width="100%"
                label="Periode Tahun"
                placeholder="Periode Tahun"
                :styling-mode="stylingMode"
                :label-mode="labelMode"
                v-model="filters.tahun"
              >
                <DxValidator>
                  <DxRequiredRule />
                </DxValidator>
              </DxSelectBox>
            </div>

            <div class="col" style="padding-left: 10px">
              <DxButton
                @click="print"
                text="Print Gaji"
                styling-mode="filled"
                type="default"
                class="validate"
                style="float: left"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss"></style>
<script>
import DxButton from "devextreme-vue/button";
import DxSelectBox from "devextreme-vue/select-box";
import { DateTime } from "luxon";

const currentYear = DateTime.now().toFormat("yyyy");
const currentMonth = DateTime.now().toFormat("M");

const months = [
  { name: "Januari", id: 1 },
  { name: "Februari", id: 2 },
  { name: "Maret", id: 3 },
  { name: "April", id: 4 },
  { name: "Mei", id: 5 },
  { name: "Juni", id: 6 },
  { name: "Juli", id: 7 },
  { name: "Agustus", id: 8 },
  { name: "September", id: 9 },
  { name: "Oktober", id: 10 },
  { name: "November", id: 11 },
  { name: "Desember", id: 12 },
];
const years = [currentYear, Number(currentYear) - 1];

export default {
  components: {
    DxButton,
    DxSelectBox,
  },
  data() {
    return {
      stylingMode: "outlined",
      //outlined, filled, underlined
      labelMode: "floating",
      bulan: currentMonth,
      tahun: currentYear,
      bulanSource: months,
      tahunSource: years,
      filters: {
        bulan: Number(currentMonth),
        tahun: currentYear,
      },
    };
  },
  mounted() {},
  methods: {
    print() {
      console.log(this.filters);
      // const tglPass = this.filters.tahun+"-"this.filters.bulan+"-01"
      const tglPass =
        this.filters.tahun.toString() +
        "-" +
        this.filters.bulan.toString() +
        "-01";
      const url = this.$router.resolve({
        name: "testing-playground",
        query: { tgl: tglPass },
      }).href;
      window.open(url, "_blank");
    },
  },
};
</script>
